import uniqid from 'uniqid'

export const generateId = () => {
    return `https://agora-data.com/Entity/${uniqid('Q')}`
}